<script lang="ts">
declare global {
  interface Window {
    jsForDetect?: boolean;
  }
}
window.jsForDetect = true;
</script>

<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';
import { useGlobalData } from '@/utils/useGlobal';
import { getConfigData, eventConfig, featureEngagementCount } from './api';
import { NMessageProvider } from "naive-ui";
import VideoPlayer from "./coms/VideoPlayer.vue";
import SubscribePop from "./coms/SubscribePop.vue";
import { loading } from "@/utils/global"
import TopBar from "./coms/m/TopBar.vue"
import { ACTIVITYTYPE } from "./const"
import { track } from '@/libs/track';

const { isPc, config, newsTabsList, currentActivity, subscribeCount, isShowDownloadButton } = useGlobalData()
const appClass = isPc.value ? 'pc' : 'wap'

const dataLoading = ref(true)
let timer: ReturnType<typeof setTimeout>;
// 获取页面配置信息
async function getConfig() {
  timer = setTimeout(() => {
    loading.show()
  }, 1000)
  try {
    let res = await getConfigData<IConfig>("base");
    if (res.length) {
      if (res[0]) {
        config.value = res[0]
        const now_date = new Date().getTime();
        // 检测是否显示下载按钮
        if (config.value.socialMedia?.downloadOpenDate.length > 0) {
          if (now_date > config.value.socialMedia.downloadOpenDate[1]) {
            // 超过下载时间 隐藏下载按钮
            isShowDownloadButton.value = false
          } else {
            isShowDownloadButton.value = true
          }
        }
      }
    }
  }catch (e) {
    console.log("getConfigData error", e)
  } finally {
    if (timer) clearTimeout(timer)
    loading.hide()
    dataLoading.value = false
  }
}
getConfig()

// 获取新闻类型
async function getNewsType() {
  try {
    const items = await getConfigData<NewsTypeData>("columns");
    if (items.length === 0) return;
    newsTabsList.value = items.reverse();
  }catch (e) {
    console.log("getNewsType error", e)
  } 
}
getNewsType()

// 获取运营活动的基础配置信息 获取到 feature_id，无需Authorization
async function getEventConfig() {
  try {
    const res = await eventConfig()
    if (res) {
      const { features } = res;
      if (Array.isArray(features)) {
        const _currentActivity = features.filter(item => item.feature_type === ACTIVITYTYPE)
        if (!_currentActivity[0]) {
          return
        }
        currentActivity.value = _currentActivity[0]
      }
    }
  }catch (e) {
    console.log("getEventConfig error", e)
  } 
}

getEventConfig()

watch(() => currentActivity.value, async (val) => {
  if (val) {
    try {
      const countRes = await featureEngagementCount({
        feature_id: val.feature_id,
        type:"user"
      })
      subscribeCount.value = countRes
    }catch (e) {
      console.log("featureEngagementCount error", e)
    } 
  }
  
}, {
  immediate: true,
});

track.trackPageView()

</script>

<template>
  <n-message-provider>
    <div class="app" :class="appClass">
      <div v-if="!isPc" class="view-direction-tip">
      请竖屏观看
    </div>
      <template v-if="!dataLoading">
        <TopBar/>
        <router-View></router-View>
        <!-- 首页顶部视频弹窗 -->
        <VideoPlayer :src="config?.topVideoUrl" />
        <SubscribePop />
      </template>
    </div>
  </n-message-provider>
</template>

<style lang="less">
html,
body {
  position: relative;
  height: 100%;
  background-color: #231b19!important;
}
#app {
  height: 100%;
  font-family: "HYJiangNanKaiSong, Microsoft YaHei",Avenir, Helvetica, Arial, sans-serif;
  font-size: 0.14rem;
  color: #fff;
}
.pc,.wap{
  height: 100%;
}

button{
  cursor: pointer;
}

.n-pagination-item{
  &:hover{
    color: #fff !important;
  }
}
.n-pagination .n-pagination-item, .n-pagination .n-pagination-item.n-pagination-item--button{
  color:#fff;
  &:hover{
    svg{
      color:#fff;

    }
  }
}
.n-pagination .n-pagination-item:not(.n-pagination-item--disabled).n-pagination-item--active{
  color:#333333;
  background-color: #fff;
  border-color:#C8C8C8;
  &:hover{
    color:#fff;
    background-color: #333333;
  }
}

.n-pagination .n-pagination-item.n-pagination-item--disabled.n-pagination-item--active, .n-pagination .n-pagination-item.n-pagination-item--disabled.n-pagination-item--button{
  background-color: transparent;
  opacity: 0.5;
}
.global-toast{
  padding: 0.2rem 0.3rem!important;
  font-size: 0.24rem;
}
.wap{
  .view-direction-tip {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    display: none;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    font-size: 0.3rem;
    color: #fff;
    text-align: center;
    background-color: #000;
  }

  @media screen and (orientation: landscape) {
    .view-direction-tip {
      z-index: 999;
      display: flex;
    }
  }
}

</style>
